export default {
    listagem: {
        titulo_pagina: 'Lista de Complementos',
        novo: 'Criar novo Complemento',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Complemento encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Complemento',
            editar: 'Editar Complemento'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Complemento'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Complemento'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Complemento'
            },
            botao_salvar : 'Salvar Complemento'
        },
        create: {
            success: 'Complemento criado com Sucesso!',
            error: 'Error ao criar Complemento!'
        },
        update: {
            success: 'Complemento editado com Sucesso!',
            error: 'Error ao editar Complemento!'
        }
    }
}
